export const OnboardingVariablesStatusesEnum = {
  AssignToAssist: {
    key: 1,
    value: "assigned-to-assist",
  },
  AssignToView: {
    key: 2,
    value: "assigned-to-view",
  },
};
